import { render, staticRenderFns } from "./LevDropdownMenu.vue?vue&type=template&id=452b5780"
import script from "./LevDropdownMenu.vue?vue&type=script&lang=js"
export * from "./LevDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports